import { PageTypeEnum, TEMPLATE_LODGING_FIELDS } from '@/constant';
import {
	GetApplicantListByLodgingIdResponse,
	GetProviderInfoListResponse,
	GetWorkerLodgingApplicantListResponse,
	TUploadExcelLodgingFailedItem,
	TUploadExcelLodgingResponse,
	UploadExcelUserInfo,
	WorkerLodgingItem,
	WorkerLodgingListItem,
} from '@/services';
import {
	formatDate,
	generateErrorMessagesUploadExcel,
	getNoNumber,
	map,
} from '@/utils';

import { range } from 'ramda';

export const formatWorkerLodgingDetail = (input: WorkerLodgingItem) => {
	return {
		...input,
		providedDate: formatDate(input.providedDate),
		inspectionDate: formatDate(input.inspectionDate),
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatWorkerLodgingListDetail = (input: WorkerLodgingListItem) => {
	return {
		...input,
		id: input?.lodgingId,
		lodgingProvidedDate: formatDate(input.lodgingProvidedDate),
		lodgingInspectionDate: formatDate(input.lodgingInspectionDate),
		lodgingRegistDt: formatDate(input.lodgingRegistDt),
		lodgingUpdateDt: formatDate(input.lodgingUpdateDt),
	};
};

export const formatWorkerLodgingList = (input: any) => {
	return map(input, formatWorkerLodgingListDetail);
};

export const formatProviderInfoList = (input: GetProviderInfoListResponse) => {
	return map(input?.content, (data, index) => ({
		...data,
		key: data?.id,
		no: getNoNumber(input, index),
	}));
};

export const formatApplicantList = (
	input: GetApplicantListByLodgingIdResponse
) => {
	return map(range(0, 10), (key: number) => ({
		key: key,
		id: key,
		no: key,
		name: `applicanName ${key}`,
		birthDay: `2024-01-01`,
		status: `status ${key}`,
		significant: `type ${key}`,
		recommenderRelationship: `reEntry ${key}`,
		entryDate: `2024-01-01`,
		departureDate: `2024-01-01`,
	}));
};
export const formatUploadExcelLodgingFailedItem = (
	input: TUploadExcelLodgingFailedItem,
	userInfo: UploadExcelUserInfo
) => {
	return {
		...input.data,

		reasonFailure: generateErrorMessagesUploadExcel({
			response: { errorList: input.errorList },
			pageType: PageTypeEnum.LODGING,
			templateFields: TEMPLATE_LODGING_FIELDS,
			userInfo,
		}),
	};
};

export const formatUploadExcelLodgingFailedList = ({
	input,
	userInfo,
}: {
	input: TUploadExcelLodgingResponse;
	userInfo: UploadExcelUserInfo;
}) => {
	return map(input, (value) =>
		formatUploadExcelLodgingFailedItem(value, userInfo)
	);
};

export const formatWorkerLodgingApplicantDetail = (
	data: GetWorkerLodgingApplicantListResponse['content'][number]
) => {
	return {
		...data,
		birthDate: formatDate(data.birthDate),
		entryDate: formatDate(data.entryDate),
		departureDate: formatDate(data.departureDate),
	};
};

export const formatWorkerLodgingApplicantList = (
	input: GetWorkerLodgingApplicantListResponse['content']
) => {
	return map(input, formatWorkerLodgingApplicantDetail);
};
